import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VerificacionService } from 'src/app/comun/services/verificacion.service';
import { MicroempresarioService } from '../../services/microempresario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { PasswordService } from '../../services/password.service';
import { personaJuridica } from '../../models/persona-juridica';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { NumeroDocumentoService } from '../../services/numero-documento.service';
import { Localidad } from 'src/app/comun/models/localidad';
import { LOCALIDADES_BOGOTA } from 'src/app/comun/data/localidades-bogota';
import {
  numeroDocumentoPorTipoDocValidator,
  getDocumentPatternMessage,
} from 'src/app/shared/utils/form-validators.util';
import { formatPesosCop, parsePesosCop } from 'src/app/shared/utils/currency-cop.util';
import { Constantes } from 'src/app/comun/data/constantes';
import { PASSWORD_COMPLEXITY_PATTERN } from 'src/app/shared/utils/validation.constants';
//jQuery
declare var $: any;

@Component({
    selector: 'formulario-persona-juridica',
    templateUrl: './formulario-juridica.html',
    providers: [TitleCasePipe],
    standalone: false
})
export class FormularioPersonaJuridica implements OnInit {
  isVisible: boolean = false;
  isConfirm: boolean = false;
  titleModal: string = 'P';
  messageAlert: string = '';
  //Selects
  departamentos: any[] = [];
  ciudades: any[] = [];
  documentos: any[] = [];
  generos: any[] = [];
  ciius: any[];
  anios: any[];
  listaTiposCont: any[];
  //Fin selects
  validarContrasena = PASSWORD_COMPLEXITY_PATTERN;
  fuentesInformacion:any[];
  isReferido:boolean=false;
  isOtraFuente:boolean=false;
  paises: any[]=[];
  isPasaporte:boolean=false;
  ventasMinimas:number=0;
  msjErrorValorVentas:string=null;
  /** Lista de dominios de correo no permitidos (PAR-160), cargada desde el back. */
  dominiosCorreoBloqueados: string[] = [];
  readonly idBogota = 11001;
  private static readonly PAR_DOMINIOS_CORREO_BLOQUEADOS = 'PAR-160';
  localidades: ReadonlyArray<Localidad> = LOCALIDADES_BOGOTA;
  currentStep = 1;
  readonly totalSteps = 2;
  /** Campos paso 1: Información general + Información financiera (mockup 05_PJ-01) */
  private readonly step1Fields: string[] = [
    'razonSocial',
    'numeroDocumento',
    'idFuenteNeocredito',
    'anioVentas',
    'valorVentas',
    'idDepartamento',
    'idCiudad',
    'codigoCiiu',
    'tiposContacto',
  ];
  /** Campos paso 2: Información de contacto (HU). personaDeContacto, minoria, camaraComercio se piden al iniciar sesión */
  private readonly step2Fields: string[] = [
    'primerNombre',
    'primerApellido',
    'idTipoDocIdentidad',
    'numeroDocumentoP',
    'confirmNumeroDocumento',
    'idGenero',
    'numeroCelular',
    'correoElectronico',
    'tratamientoDatos',
    'terminosCondiciones',
  ];

  constructor(
    private readonly _parametro: ParametrosService,
    private readonly _password: PasswordService,
    private readonly _numeroDocumento: NumeroDocumentoService,
    private readonly _microempresario: MicroempresarioService,
    private readonly route: Router,
    private readonly _verificacion: VerificacionService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly router: ActivatedRoute,
    private readonly _sweetAlert: SweetAlertService,
    public title: TitleCasePipe,
    private readonly _bancoldexService: BancoldexService,
  ) { }

  public juridicoForm = this.formBuilder.group(
    {
      idEmpresario: null,
      idUsuario: null,
      idPersonaEmpJuridico: null,
      razonSocial: ['', Validators.required],
      numeroDocumento: ['', Validators.required],
      confirmNit: [null], // HU: no se exige confirmación de NIT; DV se calcula en sistema
      digitoVerificacion: [''], // HU: se calcula en sistema, no se solicita al usuario
      anioVentas: ['', Validators.required],
      valorVentas: ['', Validators.required],
      idDepartamento: ['', [Validators.required, Validators.min(1)]],
      idCiudad: ['', [Validators.required, Validators.min(1)]],
      idLocalidad: [''],
      codigoCiiu: ['', Validators.required],
      personaDeContacto: [''], // HU: se solicita al iniciar sesión
      tipoPersonaOtro: ['', Validators.maxLength(30)],
      primerNombre: ['', Validators.required],
      segundoNombre: [''],
      primerApellido: ['', Validators.required],
      segundoApellido: [''],
      idTipoDocIdentidad: ['', Validators.required],
      numeroDocumentoP: [
        '',
        [
          Validators.required,
          numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
        ],
      ],
      confirmNumeroDocumento: [
        null,
        [
          Validators.required,
          numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
        ],
      ],
      idGenero: ['', Validators.required],
      numeroCelular: ['', Validators.required],
      correoElectronico: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,4}$'),
        ],
      ],
      contrasena: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.validarContrasena),
        ],
      ],
      confirmPassword: ['', Validators.required],
      tratamientoDatos: [false, [Validators.required, Validators.requiredTrue]],
      terminosCondiciones: [
        false,
        [Validators.required, Validators.requiredTrue],
      ],
      ciiuNombre: '',
      minoria: [''], // HU: se solicita al iniciar sesión
      minoriaDescripcion: [''],
      idFuenteNeocredito: ['', Validators.required],
      nombreReferido: [''],
      codigoReferido: [''],
      otraFuente: [''],
      numeroOpcional: [''],
      idPaisOrigen: [''],
      tiposContacto: ['', Validators.required],
      camaraComercioVigente: [''], // HU: se solicita al iniciar sesión
    },
    {
      validator: [
        this._password.matchPassword('contrasena', 'confirmPassword'),
        this._numeroDocumento.matchPassword('numeroDocumentoP', 'confirmNumeroDocumento'),
        this.validarReferidoObligatorio(),
      ],
    }
  );

  ngOnInit() {
    this.getActividades();
    this.getDocumentos();
    this.getGeneros();
    this.setPipeForm();
    this.getAnios();
    this.getPaises();
    this.getDepartamentos();
    this.loadData();
    this.getFuentes();
    this.getParametroValorMinVentas();
    this.getParametroDominiosCorreoBloqueados();
    this.getListaTiposContacto();
    this.juridicoForm.get('idTipoDocIdentidad')?.valueChanges?.subscribe(() => {
      this.juridicoForm.get('numeroDocumentoP')?.updateValueAndValidity();
      this.juridicoForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    });
    this.juridicoForm.get('numeroDocumentoP')?.valueChanges?.subscribe(() => {
      this.juridicoForm.updateValueAndValidity({ emitEvent: false });
    });
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);
  }

  //Cargar selects
  getDocumentos() {
    this._parametro.getTipoDocumentos().subscribe((data: any) => {
      if (data) {
        this.documentos = data.filter(
          (documento: any) =>
            documento.personaJuridica == 0 &&
            documento.idTipoDocIdentidad != 4 &&
            documento.idTipoDocIdentidad != 6
        );
        this.juridicoForm.get('numeroDocumentoP')?.updateValueAndValidity();
        this.juridicoForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
      }
    });
  }

  getGeneros() {
    this._parametro.getGeneros().subscribe(
      (data: any) => {
        if (data) {
          this.generos = data;
        }
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
  }

  getActividades() {
    this._parametro.getCiius().subscribe((data: any) => {
      if (data.data) {
        this.ciius = data.data;
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        };
      }
    });
  }

  getAnios() {
    this._parametro.getAnios('juridico').subscribe((data: any) => {
      if (data.anios) {
        this.anios = data.anios;
        this.anios = this.anios.filter(anio => anio != new Date().getFullYear() - 2 && anio != new Date().getFullYear());
        // HU: año anterior por defecto cuando no hay data del usuario
        if (this.anios?.length > 0 && !this.juridicoForm.get('anioVentas').value) {
          this.juridicoForm.get('anioVentas').setValue(this.anios[0]);
        }
      }
    });
  }

  getDepartamentos() {
    this._parametro
      .getDepartamentos('169')
      .subscribe((data: any) => (this.departamentos = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los departamentos');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        },500);
      });
  }

  getPaises(){
    this._parametro
      .getPaises()
      .subscribe((data: any) => (this.paises = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los paises');
      });
  }

  getParametroValorMinVentas() {
    var json = {
      idParametro: 'PAR-118',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.ventasMinimas = Number(respuesta[0].valorParametro);
        this.validarVentaAnual();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getCambio(i: any) {
    this.selectpikerChange('idDepartamento');
    this.juridicoForm.get('idCiudad').setValue('');
    $('.selectpicker').selectpicker('refresh');
    const idDepto = i?.target?.value;
    if (idDepto && idDepto !== '' && Number(idDepto) > 0) {
      this.getCiudades(Number(idDepto));
    } else {
      $('#idCiudad').prop('disabled', true);
      $('.selectpicker').selectpicker('refresh');
    }
  }

  getCiudades(idDepartamento: number) {
    this._parametro
      .getCiudades(idDepartamento.toString()).subscribe((data: any) => (this.ciudades = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar las ciudades');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', false);
          $('.selectpicker').selectpicker('refresh');
        },500);
      });
  }

  getFuentes(){
    this._microempresario.getFuentes(
      {
        tiposPersona: [
          {
            idTipoPersonaJuridica: Constantes.TIPO_PERSONA.JURIDICA
          }
        ]
      }
    ).subscribe((response:any)=>{
      if(response.exitoso){
        this.fuentesInformacion= response.fuentes;
      }else{
        this._sweetAlert.errorModal("Error",true,"Error al cargar las fuentes de información")
      }
    },
    (error) => {
      this._sweetAlert.errorModal("Error!",true,'Error al cargar las fuentes de información');
    },
    ()=>{
      setTimeout(()=>{
        $('.selectpicker').selectpicker('refresh');
      }, 300);
    });
   }

    /** Carga PAR-160 (dominios de correo bloqueados) y aplica validador al campo correo. */
  getParametroDominiosCorreoBloqueados() {
    const json = {
      idParametro: FormularioPersonaJuridica.PAR_DOMINIOS_CORREO_BLOQUEADOS,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        const data = response['data'];
        if (data && data[0] && data[0].valorParametro) {
          const valor = String(data[0].valorParametro).trim();
          this.dominiosCorreoBloqueados = valor
            .split(',')
            .map((d: string) => d.trim().toLowerCase())
            .filter((d: string) => d.length > 0);
        }
        this.agregarValidadorDominioCorreo();
      },
      () => {
        this.agregarValidadorDominioCorreo();
      }
    );
  }

  private agregarValidadorDominioCorreo() {
    const control = this.juridicoForm.get('correoElectronico');
    if (!control) return;
    const validadores = [
      Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\\.[a-z0-9-]+)*\\.[a-z]{2,4}$'),
      this.dominioCorreoBloqueadoValidator(),
    ];
    control.setValidators(validadores);
    control.updateValueAndValidity({ emitEvent: false });
  }

  private dominioCorreoBloqueadoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value == null || String(value).trim() === '') return null;
      const idx = String(value).lastIndexOf('@');
      if (idx <= 0 || idx === String(value).length - 1) return null;
      const dominio = String(value).substring(idx + 1).trim().toLowerCase();
      if (this.dominiosCorreoBloqueados.length === 0) return null;
      if (this.dominiosCorreoBloqueados.includes(dominio)) {
        return { dominioCorreoBloqueado: true };
      }
      return null;
    };
  }

  /** Mensaje de error para correo electrónico (requerido, formato, dominio bloqueado). */
  getCorreoElectronicoErrorMessage(): string {
    const c = this.juridicoForm.get('correoElectronico');
    if (!c?.errors) return '';
    if (c.hasError('required')) return 'Campo obligatorio';
    if (c.hasError('dominioCorreoBloqueado')) {
      return 'No está permitido el uso de correos temporales o de dominios no válidos para el registro.';
    }
    if (c.hasError('pattern')) return 'El correo electrónico no tiene una estructura válida (ej: correo@dominio.com).';
    return 'Correo electrónico no válido';
  }

   getListaTiposContacto(){
    this._microempresario.getListaTipoContacto().subscribe((resp: any) =>{
      this.listaTiposCont = resp;
    },
    (error) => {
      this._sweetAlert.errorModal("Error!",true,error.error);
    });
  }
  //Fin para cargar selects//

  loadData() {
    const idCampania = !this.router.snapshot.params.id
      ? null
      : this.router.snapshot.params.id;
    const token = !this.router.snapshot.params.token
      ? null
      : this.router.snapshot.params.token;
    const usuario: any = JSON.parse(sessionStorage.getItem('pre-registro'));
    if (usuario) {
      this._microempresario
        .cargarDatosRegistro('cargarRegistroJuridico', usuario.idUsuario)
        .subscribe((data: any) => {
          if (data.microempresario) {
            this.loadFields(data.microempresario);
          }
        });
    } else if (idCampania && token){
      this._microempresario.cargarRegistroJuridico({idCampania, token}).subscribe((response: any) => {
        if(response.exitoso){
          this.loadFields(response.data);
        }else{
          this._sweetAlert.errorModal("Error!",true,response.error);
        }
      });
    }
  }

  loadFields(empresario: any) {
    this.juridicoForm.get('idEmpresario').setValue(empresario.idEmpresario);
    this.juridicoForm.get('idUsuario').setValue(empresario.idUsuario);
    this.juridicoForm.get('idPersonaEmpJuridico').setValue(empresario.idPersonaEmpJuridico);
    this.juridicoForm.get('razonSocial').setValue(empresario.razonSocial);
    if (empresario.nit) {
      this.juridicoForm.get('numeroDocumento').setValue(empresario.nit);
    } else {
      this.juridicoForm.get('numeroDocumento').setValue(empresario.numeroDocumento);
    }
    this.juridicoForm.get('primerApellido').setValue(empresario.primerApellido);
    this.juridicoForm.get('primerNombre').setValue(empresario.primerNombre);
    this.juridicoForm.get('segundoApellido').setValue(empresario.segundoApellido);
    this.juridicoForm.get('segundoNombre').setValue(empresario.segundoNombre);
    this.juridicoForm.get('idGenero').setValue(empresario.idGenero);
    this.juridicoForm.get('numeroCelular').setValue(empresario.numeroCelular);
    this.juridicoForm.get('correoElectronico').setValue(empresario.correoElectronico);
    if (empresario.idDepartamento != null && empresario.idDepartamento != 0) {
      this.juridicoForm.get('idDepartamento').setValue(empresario.idDepartamento);
      $('#idDepartamento').selectpicker('val', Number(empresario.idDepartamento));
      this.getCiudades(empresario.idDepartamento);
      this.juridicoForm.get('idCiudad').setValue(empresario.idCiudad);
      $('#idCiudad').selectpicker('val', Number(empresario.idCiudad));
      if (empresario.idCiudad == this.idBogota && empresario.idLocalidad != null) {
        this.juridicoForm.get('idLocalidad').setValue(empresario.idLocalidad);
        $('#idLocalidad').selectpicker('val', Number(empresario.idLocalidad));
      } else {
        this.juridicoForm.get('idLocalidad').setValue(null);
      }
      this.validarLocalidad();
    }
    this.juridicoForm.get('tiposContacto').setValue(empresario.tiposContacto);
    this.juridicoForm.get('minoria').setValue(empresario.minoria);
    this.juridicoForm.get('minoriaDescripcion').setValue(empresario.minoriaDescripcion);
    this.juridicoForm.get('codigoCiiu').setValue(empresario.codigoCiiu);
    this.juridicoForm
      .get('personaDeContacto')
      .setValue(empresario.personaDeContacto);
    this.juridicoForm
      .get('tipoPersonaOtro')
      .setValue(empresario.tipoPersonaOtro);
    this.juridicoForm
      .get('idTipoDocIdentidad')
      .setValue(empresario.idTipoDocIdentidad);
    if (empresario.numeroDocumentoP) {
      this.juridicoForm.get('numeroDocumentoP').setValue(empresario.numeroDocumentoP);
    } else {
      this.juridicoForm.get('numeroDocumentoP').setValue(empresario.numeroDocumento);
    }
    if (empresario.ventasAnuales) {
      this.juridicoForm.get('valorVentas').setValue(formatPesosCop(empresario.ventasAnuales));
    } else {
      this.juridicoForm.get('valorVentas').setValue(formatPesosCop(empresario.valorVentas));
    }
    this.juridicoForm.get('anioVentas').setValue(empresario.anioVentas);
    this.juridicoForm.get('digitoVerificacion').setValue(empresario.digitoVerificacion);
    this.juridicoForm.get('codigoReferido').setValue(empresario.codigoReferido);
    this.juridicoForm.get('idFuenteNeocredito').setValue(empresario.idFuenteNeocredito);
    this.juridicoForm.get('nombreReferido').setValue(empresario.nombreReferido);
    this.juridicoForm.get('otraFuente').setValue(empresario.otraFuente);
    this.juridicoForm.get('numeroOpcional').setValue(empresario.numeroOpcional);
    this.juridicoForm.get('idPaisOrigen').setValue(empresario.idPaisOrigen);
    this.juridicoForm.get('camaraComercioVigente').setValue(empresario.camaraComercioVigente);
    this.validarVentaAnual();
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);
  }

  submit() {
    const json: personaJuridica = this.juridicoForm.value;
    json.valorVentas = parsePesosCop(this.juridicoForm.get('valorVentas').value);
    json.ciiuNombre = this.ciius.find(
      (c) => c.codigoCiiu == this.juridicoForm.get('codigoCiiu').value
    ).nombreCiiu;
    json.numeroDocumento = json.numeroDocumento.trim();
    json.razonSocial = json.razonSocial.toLocaleUpperCase().trim();
    json.numeroDocumentoP = json.numeroDocumentoP.toLocaleUpperCase().trim();
    json.correoElectronico = json.correoElectronico.toLocaleLowerCase().trim();
    json.primerNombre = json.primerNombre.trim();
    if (json.segundoNombre != null && json.segundoNombre != '') {
      json.segundoNombre = json.segundoNombre.trim();
    }
    json.primerApellido = json.primerApellido.trim();
    if (json.segundoApellido != null && json.segundoApellido != '') {
      json.segundoApellido = json.segundoApellido.trim();
    }
    if (json.tipoPersonaOtro != null && json.tipoPersonaOtro != '') {
      json.tipoPersonaOtro = json.tipoPersonaOtro.trim();
    }
    json.idFuenteNeocredito = Number(json.idFuenteNeocredito);
    json.idPaisOrigen = json.idTipoDocIdentidad != 2 ? Number(json.idPaisOrigen) : '';
    json.idLocalidad = json.idLocalidad ? json.idLocalidad : null;
    const nitSinDV = String(json.numeroDocumento || '').replace(/\D/g, '').slice(0, 9);
    json.digitoVerificacion = String(this.calcularDigitoVerificacionNIT(nitSinDV));
    this._microempresario.savePersonaJuridica(json).subscribe((data: any) => {
      if (data.exitoso == "true" || data.exitoso == true) {
        this._verificacion.saveParameters({
          token: data.token,
          password: data.password,
          idUsuario: data.idUsuario,
          email: json.correoElectronico,
          tipoPersona: 'juridica',
          primerNombre: json.primerNombre,
          primerApellido: json.primerApellido,
        });
        sessionStorage.setItem(
          'pre-registro',
          JSON.stringify({
            idEmpresario: data.idEmpresario,
            idUsuario: data.idUsuario,
            idPersonaEmpJuridico: data.idPersonaEmpJuridico,
            tipoPersona: 'juridica',
            primerNombre: json.primerNombre,
            primerApellido: json.primerApellido,
            idTipoDocIdentidad: json.idTipoDocIdentidad,
            // Login micro usa documento del representante, no el NIT.
            numeroDocumento: json.numeroDocumentoP,
          })
        );
        this.route.navigateByUrl('/verificacion');
      } else {
        this._sweetAlert.errorModal("Error!", true, data.error);
      }
    });
  }

  /**
   * Cálculo del dígito de verificación NIT (Colombia) según algoritmo módulo 11 DIAN.
   * Pesos de derecha a izquierda: 3, 7, 13, 17, 19, 23, 29, 37, 41.
   */
  private calcularDigitoVerificacionNIT(nitSinDV: string): number {
    const digits = nitSinDV.padStart(9, '0').slice(-9).split('').map(Number);
    const pesos = [41, 37, 29, 23, 19, 17, 13, 7, 3];
    const sum = digits.reduce((s, d, i) => s + d * pesos[i], 0);
    const remainder = sum % 11;
    return remainder <= 1 ? remainder : 11 - remainder;
  }

  //Validaciones
  validateField(key: string) {
    return (
      (this.juridicoForm.get(key).dirty ||
        this.juridicoForm.get(key)?.touched) &&
      this.juridicoForm.get(key)?.invalid
    );
  }
  
  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (
      this.juridicoForm.get('idTipoDocIdentidad').value == 5 ||
      this.juridicoForm.get('idTipoDocIdentidad').value == 3
    ) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.juridicoForm.get('numeroDocumentoP').setValue('');
    this.juridicoForm.get('confirmNumeroDocumento').setValue(null);
    if(this.juridicoForm.get('idTipoDocIdentidad').value != 2){
      this.isPasaporte=true;
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
      this.setearValidadoresForm('idPaisOrigen', [Validators.required])
    }else{
      this.isPasaporte=false;
      this.setearValidadoresForm('idPaisOrigen',null)
      this.juridicoForm.get('idPaisOrigen').setValue('');
    }
  }
  //Password
  showPassword() {
    this.isVisible = !this.isVisible;
  }

  showConfirmPassword() {
    this.isConfirm = !this.isConfirm;
  }

  setPipeForm() {
    this.juridicoForm.controls['valorVentas'].valueChanges.subscribe((data) => {
      if (data == null || data === '') {
        return;
      }
      this.juridicoForm.patchValue(
        { valorVentas: formatPesosCop(data) },
        { emitEvent: false }
      );
    });
  }

  showModal(title: string) {
    this.titleModal = title;
  }

  setValidators() {
    if (this.juridicoForm.get('personaDeContacto').value === 'Otros') {
      this.juridicoForm
        .get('tipoPersonaOtro')
        .setValidators(Validators.required);
    } else {
      this.juridicoForm.get('tipoPersonaOtro').setValidators(null);
    }
  }

  killSession() {
    sessionStorage.removeItem('pre-registro');
  }

  validateForm() {
    this.markFieldsAsTouched([...this.step1Fields, ...this.step2Fields]);
    this.markConditionalFieldsTouched();
    if (this.isStep1Valid() && this.isStep2Ready() && this.guardarFuente()) {
      this.submit();
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Diligencia correctamente los campos obligatorios antes de continuar con el proceso de registro.');
      this.selectpikerChange('codigoCiiu');
      this.selectpikerChange('idDepartamento');
      this.selectpikerChange('idCiudad');
      this.selectpikerChange('idFuenteNeocredito');
      this.selectpikerChange('idPaisOrigen');
      this.selectpikerChange('tiposContacto');
      this.selectpikerChange('idLocalidad');
    }
  }

  getDocumentPatternMessage(controlName: string): string {
    const control = this.juridicoForm.get(controlName);
    return getDocumentPatternMessage(control);
  }

  goToNextStep() {
    this.markFieldsAsTouched(this.step1Fields);
    this.markConditionalFieldsTouched();
    if (this.isStep1Valid()) {
      setTimeout(() => $('.selectpicker').selectpicker('refresh'), 300);
      this.currentStep = 2;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Diligencia correctamente los campos obligatorios de Información financiera antes de continuar.');
    }
  }

  goToPreviousStep() {
    if (this.currentStep === 1) {
      this.route.navigate(['/microempresario/registro']);
    } else {
      setTimeout(() => $('.selectpicker').selectpicker('refresh'), 300);
      this.currentStep = 1;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  isStep1Valid(): boolean {
    const baseValid = this.step1Fields.every((f) => this.juridicoForm.get(f)?.valid);
    if (!baseValid) return false;
    if (this.juridicoForm.get('idCiudad')?.value === this.idBogota && !this.juridicoForm.get('idLocalidad')?.valid) return false;
    if (this.isReferido) {
      const nom = (this.juridicoForm.get('nombreReferido')?.value ?? '').toString().trim();
      const cod = (this.juridicoForm.get('codigoReferido')?.value ?? '').toString().trim();
      if (!nom && !cod) return false;
    }
    if (this.isOtraFuente && !this.juridicoForm.get('otraFuente')?.valid) return false;
    return true;
  }

  isStep2Ready(): boolean {
    return this.step2Fields.every((f) => this.juridicoForm.get(f)?.valid)
      && (this.juridicoForm.get('idTipoDocIdentidad')?.value != 2 || this.juridicoForm.get('idPaisOrigen')?.valid);
  }

  private validarReferidoObligatorio(): (control: AbstractControl) => ValidationErrors | null {
    return (group: AbstractControl): ValidationErrors | null => {
      const idFuente = group.get?.('idFuenteNeocredito')?.value;
      const nombre = (group.get?.('nombreReferido')?.value ?? '').toString().trim();
      const codigo = (group.get?.('codigoReferido')?.value ?? '').toString().trim();
      const nomControl = group.get?.('nombreReferido');
      if (idFuente === '7' || idFuente === 7) {
        if (!nombre && !codigo) {
          nomControl?.setErrors({ ...nomControl?.errors, referidoRequired: true });
          return { referidoRequired: true };
        }
      }
      if (nomControl?.errors?.['referidoRequired']) {
        const err = { ...nomControl.errors };
        delete err['referidoRequired'];
        nomControl.setErrors(Object.keys(err).length ? err : null);
      }
      return null;
    };
  }

  private markFieldsAsTouched(fields: string[]) {
    fields.forEach((f) => {
      const c = this.juridicoForm.get(f);
      c?.markAsTouched();
      c?.updateValueAndValidity();
    });
  }

  private markConditionalFieldsTouched() {
    if (this.juridicoForm.get('idCiudad')?.value === this.idBogota) {
      this.juridicoForm.get('idLocalidad')?.markAsTouched();
      this.juridicoForm.get('idLocalidad')?.updateValueAndValidity();
    }
    if (this.isReferido) {
      this.juridicoForm.get('nombreReferido')?.markAsTouched();
      this.juridicoForm.get('codigoReferido')?.markAsTouched();
      this.juridicoForm.updateValueAndValidity();
    }
    if (this.isOtraFuente) {
      this.juridicoForm.get('otraFuente')?.markAsTouched();
      this.juridicoForm.get('otraFuente')?.updateValueAndValidity();
    }
    if (this.juridicoForm.get('idTipoDocIdentidad')?.value != 2) {
      this.juridicoForm.get('idPaisOrigen')?.markAsTouched();
      this.juridicoForm.get('idPaisOrigen')?.updateValueAndValidity();
    }
  }

  selectpikerChange(field: string) {
    $(`#${field}`).selectpicker('destroy');
    let valid = this.validateField(field);
    if (!valid) {
      $(`#${field}`).removeClass('is-invalid');
    } else {
      $(`#${field}`).addClass('is-invalid');
    }
    $(`#${field}`).addClass('selectpicker');
    $(`#${field}`).selectpicker('render');
  }

  selectpikerChangeContactos(field: string) {
    let valid = this.validateField(field);
    const tiposContactoElement = document.getElementById('tiposContacto');
    if (valid) {
      tiposContactoElement.classList.add('is-invalid');
    } else {
      if (tiposContactoElement.classList.contains('is-invalid')) {
        $(`#${field}`).selectpicker('destroy');
      }
      tiposContactoElement.classList.remove('is-invalid');
    }
    $(`#${field}`).selectpicker('refresh');
  }

  validarMinoria(numero:number) {
    if (numero == 1) {
      this.setearValidadoresForm('minoriaDescripcion', [
        Validators.required,
      ]);
    } else {
      this.setearValidadoresForm('minoriaDescripcion', null);
    }
  }

  onCiudadChange() {
      this.selectpikerChange('idCiudad');
      this.validarLocalidad();
    }
  
    validarLocalidad() {
      if(this.juridicoForm.get('idCiudad').value == this.idBogota){
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        }, 300);
        this.setearValidadoresForm('idLocalidad', [Validators.required])
      }else{
        this.setearValidadoresForm('idLocalidad',null)
        this.juridicoForm.get('idLocalidad').setValue(null);
      }
    }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.juridicoForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.juridicoForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  validarTexto(e){
    e.target.value = this.title.transform(e.target.value);
  }

  guardarFuente():boolean{
    if(this.juridicoForm.get('idFuenteNeocredito').value=='7'){            
      if(this.juridicoForm.get('nombreReferido').value != '' || this.juridicoForm.get('codigoReferido').value != ''){
        this.juridicoForm.get('otraFuente').setValue('');
        return true;
      }else{
        this.juridicoForm.get('otraFuente').setValue('');
        return false;
      }
    }else if(this.juridicoForm.get('idFuenteNeocredito').value=='8'){
      this.juridicoForm.get('nombreReferido').setValue('');
      this.juridicoForm.get('codigoReferido').setValue('');
      return true;
    }else{
      return true;
    }   
  }

  valueSelected(valueId:any){
    this.selectpikerChange('idFuenteNeocredito');
    if(valueId == '7'){
      this.isReferido=true;
      this.isOtraFuente=false;
      this._sweetAlert.infoModal("Información",true,"Debe registrar por lo menos uno de los dos campos, ¿Quién te refirió? ó El código del referido")
      this.setearValidadoresForm('otraFuente',null);
    }else if(valueId == '8'){
      this.isOtraFuente=true;
      this.isReferido=false;
      this.setearValidadoresForm('otraFuente',[Validators.required]);
    }else{
      this.isReferido=false;
      this.isOtraFuente=false;
      this.setearValidadoresForm('otraFuente',null);
    }
  }

  validarVentaAnual(){
    const ventaMinima = formatPesosCop(this.ventasMinimas);
    if (this.juridicoForm.get('valorVentas').value) {
      if (parsePesosCop(this.juridicoForm.get('valorVentas').value) < this.ventasMinimas) {
        this.juridicoForm.get('valorVentas').setErrors({ incorrect: true });
        this.msjErrorValorVentas = "Campo obligatorio. El monto mínimo es de " + ventaMinima + " pesos.";
      }
    }else{
      this.msjErrorValorVentas = "Campo obligatorio";
    }
  }
}
